<mat-toolbar [style.display]="receipt?.allLinesReceived() ? 'flex' : 'none'" #receiptCompletePanel role="toolbar"
    style="background-color:transparent; padding: 0 5px;">
    <span>Receipt Complete</span>
    <span style="flex: 1 1 auto;"></span>
    <button mat-raised-button color="primary" (click)="releaseReceipt()">
        <mat-icon>install_desktop</mat-icon>
        <span>Release</span>
    </button>
</mat-toolbar>

<form [formGroup]="searchForm">
    <table>
        <tr>
            <td style="width:100%;">
                <mat-form-field appearance="fill" style="width:100%;">
                    <mat-label>Search:</mat-label>
                    <input matInput formControlName="search" (keydown.enter)="performSearch($event)">
                    <button *ngIf="searchValue" matSuffix mat-icon-button (click)="searchReset()">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </td>
            <td style="vertical-align: middle;">
                <button mat-button [matMenuTriggerFor]="receiptMenu">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #receiptMenu>
                    <button mat-menu-item (click)="releaseReceipt()">
                        <mat-icon>install_desktop</mat-icon>
                        <span>Release Receipt</span>
                    </button>
                    <button mat-menu-item (click)="pickLabelPrinter().subscribe()">
                        <mat-icon>print</mat-icon>
                        <span>Select Printer</span>
                    </button>
                </mat-menu>
            </td>
        </tr>
    </table>

</form>

<mat-accordion *ngIf="receipt" class="receipt-detail-pane">
    <mat-expansion-panel *ngFor="let detail of receipt.Details" #receiptDetailPanel hideToggle
        [attr.data-linenbr]="detail.LineNbr">
        <mat-expansion-panel-header class="right-aligned-header">
            <mat-panel-title #itemThumbnail>
                <item-thumbnail [item]="detail.item"></item-thumbnail>
                <mat-icon *ngIf="detail.allPiecesReceived()">checkmark</mat-icon>
                <div>{{detail.InventoryID}}<br />
                    <span *ngIf="detail.AlternateID" style="font-size:0.8em;">{{detail.AlternateID}}</span>
                </div>
            </mat-panel-title>
            <mat-panel-description>
                <button matSuffix mat-button [matMenuTriggerFor]="itemMenu" (click)="$event.stopPropagation()">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #itemMenu>
                    <button mat-menu-item (click)="receivedAllPieces(detail)">
                        <mat-icon>archive</mat-icon>
                        <span>Received All Pieces</span>
                    </button>
                    <a mat-menu-item [routerLink]="['/item', detail.InventoryID]" target="_blank">
                        <mat-icon>not_listed_location</mat-icon>
                        <span>Item Inquiry</span>
                    </a>
                </mat-menu>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <!-- Allocations table -->
        <div id="allocations-wrapper">
            <table mat-table class="allocations-table" [dataSource]="detail.Allocations" style="width:100%;">
                <ng-container matColumnDef="LotSerialNbr">
                    <th mat-header-cell *matHeaderCellDef>Lot #</th>
                    <td mat-cell *matCellDef="let allocation" class="lotsernbr">{{allocation.LotSerialNbr}}</td>
                </ng-container>
                <ng-container matColumnDef="Qty">
                    <th mat-header-cell *matHeaderCellDef>Qty</th>
                    <td mat-cell *matCellDef="let allocation">{{allocation.Qty}}</td>
                </ng-container>
                <ng-container matColumnDef="PrimaryAction">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell matSuffix *matCellDef="let allocation" class="item-action">
                        <button *ngIf="!allocation.received" mat-raised-button type="button"
                            (click)="receivedPiece(detail, allocation).subscribe()" color="accent">
                            <mat-icon>archive</mat-icon>
                        </button>
                        <button mat-button *ngIf="allocation.received" [matMenuTriggerFor]="receiptLineMenu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #receiptLineMenu>
                            <button mat-menu-item (click)="unreceivePiece(detail, allocation)">
                                <mat-icon>unarchive</mat-icon>
                                <span>Undo Received</span>
                            </button>
                            <button mat-menu-item (click)="printStockTag(detail, allocation)">
                                <mat-icon>print</mat-icon>
                                <span>Reprint Label</span>
                            </button>
                            <button mat-menu-item (click)="editPieceDetails(detail, allocation)">
                                <mat-icon>edit</mat-icon>
                                <span>Edit Lot / Qty</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="allocationsDisplayColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: allocationsDisplayColumns;"></tr>
            </table>
        </div>
    </mat-expansion-panel>
</mat-accordion>

<ng-template #editReceiptDetailDialog let-data>
    <form [formGroup]="editPieceForm">
        <mat-dialog-content>
            <mat-label>Item: </mat-label><span>{{data.ReceiptLine.InventoryID}}</span><br />
            <span>{{data.ReceiptLine.item.Description}}</span>
            <mat-form-field appearance="fill" style="width:100%;">
                <mat-label>Lot / Serial #:</mat-label>
                <input matInput formControlName="SerLotNbr">
                <button *ngIf="editPieceLotNbr" matSuffix mat-icon-button (click)="editPieceLotNbr = null">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field appearance="fill" style="width:100%;">
                <mat-label>Piece Qty:</mat-label>
                <input matInput formControlName="Qty" inputmode="quantity">
                <button *ngIf="editPieceQty" matSuffix mat-icon-button (click)="editPieceQty = null">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </mat-dialog-content>
        <mat-dialog-actions style="justify-content: space-between;">
            <button matSuffix mat-raised-button mat-dialog-close style="justify-content: flex-end;">Cancel</button>
            <button matSuffix mat-raised-button color="primary" [mat-dialog-close]="true"
                style="justify-content: flex-end;" [disabled]="!editPieceLotNbr || !editPieceQty">OK</button>
        </mat-dialog-actions>
    </form>
</ng-template>